import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOvalBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 20,
	viewBox: "0 0 44 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 20,
			rx: 10,
			fill: "#F3E5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5 11.375C32.5 11.5859 32.3125 11.75 32.125 11.75H29.875C29.6641 11.75 29.5 11.5859 29.5 11.375V10.25H25V13.625C25 14.2344 25.5156 14.75 26.125 14.75H35.875C36.4609 14.75 37 14.2344 37 13.625V10.25H32.5V11.375ZM35.875 5.75H34V4.625C34 4.03906 33.4609 3.5 32.875 3.5H29.125C28.5156 3.5 28 4.03906 28 4.625V5.75H26.125C25.5156 5.75 25 6.28906 25 6.875V9.5H37V6.875C37 6.28906 36.4609 5.75 35.875 5.75ZM32.875 5.75H29.125V4.625H32.875V5.75Z",
			fill: "#AA00FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.44 8H6L8.46 10.46L13.36 15.36L15.09 13.61L11.94 10.46H20.61V8H8.63H8.44Z",
			fill: "#AA00FF"
		})
	]
});
const ForwardRef = forwardRef(SvgOvalBack);
export { ForwardRef as ReactComponent };
